import '@fino/lib-injection';

export class CancelableRequest {
  constructor(injections, options) {
    // Assign given injections to the service instance
    this.constructor.injectArguments(this, injections, options);

    // Ensure that the mandatory injections are available
    this.constructor.contractInjection(this, '$q');
    this.constructor.contractInjection(this, 'appConfig');

    // Holds all request handlers for cancellation
    this.requests = {};
  }

  get config() {
    return this.appConfig.get();
  }

  get api() {
    const { host, path, version } = this.config.api;
    return `${host}${path}/${version}`;
  }

  createRequestHandler(reqId) {
    // Cancel request if available
    this.cancelRequest(reqId);

    // Create and return new request handler
    return (this.requests[reqId] = this.$q.defer());
  }

  removeRequestHandler(reqId) {
    // Remove actual resolved request handler
    if (this.requests[reqId]) {
      delete this.requests[reqId];
    }
  }

  cancelRequest(reqId) {
    // Cancel request if available
    if (this.requests[reqId]) {
      this.requests[reqId].resolve();
    }
  }

  cancelable(promise, request) {
    request.then(promise.resolve);
    request.catch(promise.reject);
    return promise;
  }
}
